import type { FC } from 'react';
import React from 'react';

import Progressbar from '../components/ui/Progressbar';

interface IStepConfirmationProps {
  reset: () => void;
  error?: boolean;
}

const StepConfirmation: FC<IStepConfirmationProps> = ({
  reset,
  error = false
}) => {
  return (
    <div className="box">
      <div className="box-content">
        <Progressbar reset={reset} error={error} />
      </div>
    </div>
  );
};

export default StepConfirmation;
